import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  timeout: 30000,
});

export const isNetworkError = (e) => !e?.response && (e?.code === "ERR_NETWORK" || e?.code === "ECONNABORTED" || e?.message === "Network Error");

export function errMsg(e) {
  if (isNetworkError(e)) return "Can't reach the server right now. Check your connection and try again.";
  if (e?.response?.status >= 500 && !e?.response?.data?.detail) return "The server had a problem. Please try again in a moment.";
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => (d && typeof d.msg === "string" ? d.msg.replace(/^Value error, /, "") : JSON.stringify(d))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
